import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ArrowRight } from "lucide-react";
import { FAQ } from "@/lib/content";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <div data-testid="faq-page">
      {/* HERO */}
      <section className="bg-ink text-white relative overflow-hidden nx-hero-faq" style={{ paddingTop: 200, paddingBottom: 120 }}>
        <div className="absolute inset-0 nx-hero-grid opacity-50"></div>
        <div
          className="absolute -bottom-32 -right-32 w-[500px] h-[500px] rounded-full opacity-15"
          style={{ background: "radial-gradient(circle, #2563EB 0%, transparent 70%)" }}
        ></div>
        <div className="nx-container relative">
          <div className="max-w-3xl nx-fade-up">
            <span className="nx-overline">Foire aux questions</span>
            <h1 className="text-white" style={{ marginTop: 24, marginBottom: 32 }}>
              Vos questions, <span style={{ color: "#00C8FF" }}>nos réponses claires.</span>
            </h1>
            <p className="text-mist" style={{ fontSize: 20, marginBottom: 0 }}>
              Les principales interrogations que nous rencontrons avant chaque mise en place d'un contrat de Facility Management.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ LIST */}
      <section className="bg-white nx-arch-grid-light" style={{ paddingTop: 120, paddingBottom: 120 }}>
        <div className="nx-container" style={{ maxWidth: 900 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {FAQ.map((item, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={item.q}
                  style={{
                    border: "1px solid rgba(13,43,69,0.1)",
                    borderRadius: 10,
                    background: isOpen ? "rgba(0,200,255,0.04)" : "#FFFFFF",
                    borderColor: isOpen ? "rgba(0,200,255,0.35)" : "rgba(13,43,69,0.1)",
                    transition: "all 0.25s",
                  }}
                  data-testid={`faq-item-${i}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    style={{
                      width: "100%",
                      padding: "24px 28px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 16,
                      background: "transparent",
                      cursor: "pointer",
                      textAlign: "left",
                      color: "#0D2B45",
                      fontFamily: "Exo 2",
                      fontWeight: 600,
                      fontSize: 18,
                    }}
                  >
                    <span>{item.q}</span>
                    <ChevronDown
                      size={22}
                      strokeWidth={1.75}
                      style={{
                        color: "#00C8FF",
                        transform: isOpen ? "rotate(180deg)" : "rotate(0)",
                        transition: "transform 0.25s",
                      }}
                    />
                  </button>
                  {isOpen && (
                    <div
                      style={{
                        padding: "0 28px 24px",
                        color: "#475569",
                        fontFamily: "Exo 2",
                        fontSize: 17,
                        lineHeight: 1.7,
                      }}
                    >
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-navy text-white nx-arch-skyline-dark" style={{ paddingTop: 120, paddingBottom: 120 }}>
        <div className="nx-container text-center">
          <span className="nx-overline">Une question spécifique ?</span>
          <h2 className="text-white" style={{ marginTop: 24, marginBottom: 32, maxWidth: 800, marginLeft: "auto", marginRight: "auto" }}>
            Nos équipes vous répondent sous 24h ouvrées.
          </h2>
          <Link to="/contact" className="nx-btn nx-btn-primary" data-testid="faq-cta">
            Poser votre question <ArrowRight size={18} strokeWidth={2} />
          </Link>
        </div>
      </section>
    </div>
  );
}
